export enum Toggle {
    Append = 0,
    Remove = 1,
}
